import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { ErrorBoundary } from './components/core';
import { AuthProvider } from './api/auth/authContext';
import { PermissionsProvider } from './api/auth/PermissionsContext';
import { ClientCodeProvider } from './api/auth/ClientCodeContext';
import { Toaster } from 'sonner';

// Import Inter font from Google Fonts
const fontLink = document.createElement('link');
fontLink.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&display=swap';
fontLink.rel = 'stylesheet';
document.head.appendChild(fontLink);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <AuthProvider>
        <PermissionsProvider>
          <ClientCodeProvider>
            <App />
            <Toaster
              position="top-right"
              richColors
              expand
              closeButton
              duration={5000}
              toastOptions={{
                style: { fontFamily: "'Inter', 'Roboto', 'Helvetica Neue', Arial, sans-serif" },
                classNames: { toast: 'sonner-toast' },
              }}
              offset={16}
              visibleToasts={4}
            />
          </ClientCodeProvider>
        </PermissionsProvider>
      </AuthProvider>
    </ErrorBoundary>
  </React.StrictMode>
);